import { useCallback } from "react";
import { rangeToString } from "@madmedical/utils";
import { useDispatch, useSelector } from "../context";
import { portioningDateRangeSelector } from "./selectors";
import { setPortioningDateRange as setDateRangeAction } from "./slice";
export default () => {
    const dateRange = useSelector(portioningDateRangeSelector);
    const dispatch = useDispatch();
    const setDateRange = useCallback((newValue) => {
        dispatch(setDateRangeAction(rangeToString(newValue)));
    }, [dispatch]);
    return { dateRange, setDateRange };
};
